@layer settings {
  :root {
    --core-shadow-1: var(--fdt-core-elevation-1-x)
        var(--fdt-core-elevation-1-y)
        var(--fdt-core-elevation-1-blur)
        var(--fdt-core-elevation-1-spread)
        var(--fdt-core-elevation-1-color);
    --core-shadow-2: var(--fdt-core-elevation-2-x)
        var(--fdt-core-elevation-2-y)
        var(--fdt-core-elevation-2-blur)
        var(--fdt-core-elevation-2-spread)
        var(--fdt-core-elevation-2-color);
    --core-shadow-3: var(--fdt-core-elevation-3-x)
        var(--fdt-core-elevation-3-y)
        var(--fdt-core-elevation-3-blur)
        var(--fdt-core-elevation-3-spread)
        var(--fdt-core-elevation-3-color);
    --core-shadow-4: var(--fdt-core-elevation-4-x)
        var(--fdt-core-elevation-4-y)
        var(--fdt-core-elevation-4-blur)
        var(--fdt-core-elevation-4-spread)
        var(--fdt-core-elevation-4-color);
    --core-background-shadow: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.04) 0%,
        rgba(0, 0, 0, 0.0398787) 3.93%,
        rgba(0, 0, 0, 0.0394988) 7.09%,
        rgba(0, 0, 0, 0.038836) 9.77%,
        rgba(0, 0, 0, 0.0378661) 12.21%,
        rgba(0, 0, 0, 0.0365649) 14.69%,
        rgba(0, 0, 0, 0.0349081) 17.48%,
        rgba(0, 0, 0, 0.0328716) 20.83%,
        rgba(0, 0, 0, 0.030431) 25.02%,
        rgba(0, 0, 0, 0.0275622) 30.3%,
        rgba(0, 0, 0, 0.0242409) 36.96%,
        rgba(0, 0, 0, 0.020443) 45.24%,
        rgba(0, 0, 0, 0.0161442) 55.42%,
        rgba(0, 0, 0, 0.0113202) 67.76%,
        rgba(0, 0, 0, 0.00594689) 82.53%,
        rgba(0, 0, 0, 0) 100%
    );
  }
}
@layer settings {
  :root {
    --scrollbar-size: var(--fdt-core-spacing-1);
    --scrollbar-foreground-color: var(--fdt-semantic-color-background-neutral);
    --scrollbar-background-color: transparent;
    --scrollbar-border-radius: var(--fdt-core-borderradius-small);
  }
}
@layer settings {
  :root {
    --z-index-sun: 9999999;
    --z-index-mercury: 1000000;
    --z-index-venus: 100000;
    --z-index-earth: 12000;
    --z-index-mars: 5000;
    --z-index-jupiter: 1000;
    --z-index-saturn: 600;
    --z-index-uranus: 400;
    --z-index-neptune: 200;
    --z-index-dwarf-planet: 100;
    --z-index-pluto: 50;
    --pg-header--z-index: var(--z-index-earth);
    --toast--z-index: var(--z-index-mars);
    --wc-floating-menu-panel--z-index: var(--z-index-neptune);
  }
}
@layer settings {
  :root {
    --divider--width: var(--fdt-semantic-borderwidth-default);
    --divider--style: solid;
    --divider--color: var(--fdt-semantic-color-border-default);
    --divider: var(--divider--width) var(--divider--style) var(--divider--color);
    --divider-light--color: var(--fdt-semantic-color-foreground-subtle);
  }
}
:root {
  --from-mobile: 26.5625em;
  --from-tablet: 40em;
  --from-desktop: 64em;
  --from-wide: 80em;
}

:root {
  --overlay-black: linear-gradient(78.43deg, rgba(0, 0, 0, 0.5) 40.45%, rgba(0, 0, 0, 0) 84.85%);
  --overlay-black-center: linear-gradient(86.58deg, rgba(0, 0, 0, 0) 12.47%, rgba(0, 0, 0, 0.65) 27.5%, rgba(0, 0, 0, 0.614674) 79.17%, rgba(0, 0, 0, 0) 93.8%);
  --overlay-card-media: linear-gradient(180deg, rgba(0, 0, 0, 0.06) 15.1%, rgba(0, 0, 0, 0.6) 100%);
  --overlay-card-media-hover: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 15.1%, rgba(0, 0, 0, 0.8) 100%);
  --overlay-black--block-end: linear-gradient(180deg, rgba(0, 0, 0, 0) 33.69%, rgba(0, 0, 0, 0.85) 91.91%);
}

@layer reset {
  /***
  The new CSS reset - version 1.11.2 (last updated 15.11.2023)
  GitHub page: https://github.com/elad2412/the-new-css-reset
  ***/
  /*
      Remove all the styles of the "User-Agent-Stylesheet", except for the 'display' property
      - The "symbol *" part is to solve Firefox SVG sprite bug
      - The "html" element is excluded, otherwise a bug in Chrome breaks the CSS hyphens property (https://github.com/elad2412/the-new-css-reset/issues/36)
  */
  *:where(:not(html, iframe, canvas, img, svg, video, audio, [slot=content]):not(svg *, symbol *)) {
    all: unset;
    display: revert;
  }
  /* Preferred box-sizing value */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  /* Fix mobile Safari increase font-size on landscape mode */
  html {
    -moz-text-size-adjust: none;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
  }
  /* Reapply the pointer cursor for anchor tags */
  a, button {
    cursor: revert;
  }
  /* Remove list styles (bullets/numbers) */
  ol, ul, menu, summary {
    list-style: none;
  }
  /* For images to not be able to exceed their container */
  img {
    max-inline-size: 100%;
    max-block-size: 100%;
  }
  /* removes spacing between cells in tables */
  table {
    border-collapse: collapse;
  }
  /* Safari - solving issue when using user-select:none on the <body> text input doesn't working */
  input, textarea {
    -webkit-user-select: auto;
  }
  /* revert the 'white-space' property for textarea elements on Safari */
  textarea {
    white-space: revert;
  }
  /* minimum style to allow to style meter element */
  meter {
    -webkit-appearance: revert;
    appearance: revert;
  }
  /* preformatted text - use only for this feature */
  :where(pre) {
    all: revert;
    box-sizing: border-box;
  }
  /* reset default text opacity of input placeholder */
  ::placeholder {
    color: unset;
  }
  /* fix the feature of 'hidden' attribute.
  display:revert; revert to element instead of attribute */
  :where([hidden]) {
    display: none;
  }
  /* revert for bug in Chromium browsers
  - fix for the content editable attribute will work properly.
  - webkit-user-select: auto; added for Safari in case of using user-select:none on wrapper element*/
  :where([contenteditable]:not([contenteditable=false])) {
    -moz-user-modify: read-write;
    -webkit-user-modify: read-write;
    overflow-wrap: break-word;
    -webkit-line-break: after-white-space;
    -webkit-user-select: auto;
  }
  /* apply back the draggable feature - exist only in Chromium and Safari */
  :where([draggable=true]) {
    -webkit-user-drag: element;
  }
  /* Revert Modal native behavior */
  :where(dialog:modal) {
    all: revert;
    box-sizing: border-box;
  }
  /* Remove details summary webkit styles */
  ::-webkit-details-marker {
    display: none;
  }
  wc-header, .c-pg-footer {
    display: block !important;
    z-index: -1 !important;
  }
}
@layer reset {
  /* Alternate packages: 
    - https://www.npmjs.com/package/modern-normalize
    - https://www.npmjs.com/package/sanitize.css?activeTab=versions
        // @forward "../../../node_modules/sanitize.css/sanitize.css";
        // @forward "../../../node_modules/sanitize.css/assets.css";
        // @forward "../../../node_modules/sanitize.css/forms.css";
        // @forward "../../../node_modules/sanitize.css/reduce-motion.css";
    */
}
:root {
  --scroll-behavior: smooth;
  --view-height-max: 100vh;
  --view-width-max: 100vw;
}
@media screen and (prefers-reduced-motion: reduce) {
  :root {
    --scroll-behavior: auto;
  }
}
@supports (height: 100dvh) {
  :root {
    --view-height-max: 100dvh;
    --view-width-max: 100dvw;
  }
}

@layer elements {
  :where(html) {
    min-height: 100%;
    /* mobile viewport bug fix */
    min-height: -webkit-fill-available;
    height: 100%;
    scroll-behavior: var(--scroll-behavior);
    overflow-x: hidden;
    max-height: var(--scrollbar--max-height, 100%);
    overflow-y: var(--scrollbar--overflow-y, auto);
    overflow-x: var(--scrollbar--overflow-x, hidden);
  }
  @supports (-moz-appearance: none) {
    :where(html) {
      scrollbar-width: thin;
      scrollbar-color: var(--scrollbar-foreground-color) var(--scrollbar-background-color);
    }
  }
  :where(html)::-webkit-scrollbar {
    width: var(--scrollbar-size);
    height: var(--scrollbar-size);
  }
  :where(html)::-webkit-scrollbar-button {
    display: none;
  }
  :where(html)::-webkit-scrollbar-thumb {
    border-radius: var(--scrollbar-border-radius);
    background-color: var(--scrollbar-foreground-color);
    background-clip: padding-box;
  }
  :where(html)::-webkit-scrollbar-track {
    border-radius: var(--scrollbar-border-radius);
    background: var(--scrollbar-background-color);
  }
  :where(body) {
    font-family: var(--fdt-core-fontfamily-body);
    font-size: var(--fdt-core-fontsize-base);
    line-height: var(--fdt-core-lineheight-paragraph);
    color: var(--fdt-semantic-color-foreground-default);
    min-height: var(--view-height-max);
    min-height: -webkit-fill-available;
    display: flex;
    flex-direction: column;
  }
  :where(main) {
    flex: 1 0 auto;
  }
  :target {
    scroll-margin-block-start: var(--scrolling-margin, var(--fdt-core-spacing-6));
  }
}
@layer elements {
  :where(h1, .u-h1, h2, .u-h2, h3, .u-h3, h4, .u-h4, h5, .u-h5, h6, .u-h6) {
    font-family: var(--set-heading--ff, var(--heading--ff));
    font-size: var(--set-heading--fs, var(--heading--fs));
    line-height: var(--set-heading--lh, var(--heading--lh));
    font-weight: var(--set-heading--fw, var(--heading--fw));
    letter-spacing: var(--set-heading--ls, var(--heading--ls));
    color: var(--set-heading--color, var(--heading--color, currentColor));
    margin-block-end: var(--set-heading--mbe, var(--heading--mbe));
    margin-block-start: var(--set-heading--mbs, 0);
    margin-inline-start: var(--set-heading--mis, 0);
    margin-inline-end: var(--set-heading--mie, 0);
    text-transform: var(--set-heading--tt, var(--heading--tt));
    text-wrap: var(--set-heading--tw, balance);
  }
  .u-h-display {
    --heading--ff: var(--fdt-core-heading-display-fontfamily);
    --heading--fs: clamp(
      var(--fdt-mobile-fontsize-9),
      -0.448rem + 7.143vw,
      var(--fdt-core-heading-display-fontsize)
    );
    --heading--lh: var(--fdt-core-heading-display-lineheight);
    --heading--fw: var(--fdt-core-heading-display-fontweight);
    --heading--ls: var(--fdt-core-heading-display-letterspacing);
    --heading--color: var(--fdt-core-color-typography-heading-display);
    --heading--mbe: var(
      --heading-display--mbe,
      var(--fdt-core-spacing-4)
    );
    --heading--tt: var(--fdt-core-heading-display-textcase);
  }
  .u-h-caption {
    --heading--ff: var(--fdt-core-heading-caption-fontfamily);
    --heading--fs: var(--fdt-core-heading-caption-fontsize);
    --heading--fw: var(--fdt-core-heading-caption-fontweight);
    --heading--lh: var(--fdt-core-heading-caption-lineheight);
    --heading--ls: var(--fdt-core-heading-caption-letterspacing);
    --heading--mbe: var(
      --heading-caption--mbe,
      var(--fdt-core-spacing-1)
    );
    --heading--tt: var(--fdt-core-heading-caption-textcase);
  }
  :where(h1, .u-h1) {
    --heading--ff: var(--fdt-core-heading-h1-fontfamily);
    --heading--fs: clamp(var(--fdt-mobile-fontsize-8), -0.125rem + 4vw, var(--fdt-core-heading-h1-fontsize));
    --heading--lh: var(--fdt-core-heading-h1-lineheight);
    --heading--fw: var(--fdt-core-heading-h1-fontweight);
    --heading--ls: var(--fdt-core-heading-h1-letterspacing);
    --heading--color: var(--fdt-core-color-typography-heading-h1);
    --heading--mbe: var(
      --e-heading-h1-mbe,
      var(--fdt-core-spacing-4)
    );
    --heading--tt: var(--fdt-core-heading-h1-textcase);
  }
  :where(h2, .u-h2) {
    --heading--ff: var(--fdt-core-heading-h2-fontfamily);
    --heading--fs: clamp(var(--fdt-mobile-fontsize-7), 0.163rem + 2.286vw, var(--fdt-core-heading-h2-fontsize));
    --heading--lh: var(--fdt-core-heading-h2-lineheight);
    --heading--fw: var(--fdt-core-heading-h2-fontweight);
    --heading--ls: var(--fdt-core-heading-h2-letterspacing);
    --heading--color: var(--fdt-core-color-typography-heading-h2);
    --heading--mbe: var(
      --e-heading-h2-mbe,
      var(--fdt-core-spacing-4)
    );
    --heading--tt: var(--fdt-core-heading-h2-textcase);
  }
  :where(h3, .u-h3) {
    --heading--ff: var(--fdt-core-heading-h3-fontfamily);
    --heading--fs: clamp(var(--fdt-mobile-fontsize-6), 0.214rem + 2vw, var(--fdt-core-heading-h3-fontsize));
    --heading--lh: var(--fdt-core-heading-h3-lineheight);
    --heading--fw: var(--fdt-core-heading-h3-fontweight);
    --heading--ls: var(--fdt-core-heading-h3-letterspacing);
    --heading--color: var(--fdt-core-color-typography-heading-h3);
    --heading--mbe: var(
      --e-heading-h3-mbe,
      var(--fdt-core-spacing-3)
    );
    --heading--tt: var(--fdt-core-heading-h3-textcase);
  }
  :where(h4, .u-h4) {
    --heading--ff: var(--fdt-core-heading-h4-fontfamily);
    --heading--fs: clamp(var(--fdt-mobile-fontsize-5), 0.393rem + 1vw, var(--fdt-core-heading-h4-fontsize));
    --heading--lh: var(--fdt-core-heading-h4-lineheight);
    --heading--fw: var(--fdt-core-heading-h4-fontweight);
    --heading--ls: var(--fdt-core-heading-h4-letterspacing);
    --heading--color: var(--fdt-core-color-typography-heading-h4);
    --heading--mbe: var(
      --e-heading-h4-mbe,
      var(--fdt-core-spacing-3)
    );
    --heading--tt: var(--fdt-core-heading-h4-textcase);
  }
  :where(h5, .u-h5) {
    --heading--ff: var(--fdt-core-heading-h5-fontfamily);
    --heading--fs: clamp(var(--fdt-mobile-fontsize-4), 0.73rem + 0.571vw, var(--fdt-core-heading-h5-fontsize));
    --heading--lh: var(--fdt-core-heading-h5-lineheight);
    --heading--fw: var(--fdt-core-heading-h5-fontweight);
    --heading--ls: var(--fdt-core-heading-h5-letterspacing);
    --heading--color: var(--fdt-core-color-typography-heading-h5);
    --heading--mbe: var(
      --e-heading-h5-mbe,
      var(--fdt-core-spacing-3)
    );
    --heading--tt: var(--fdt-core-heading-h5-textcase);
  }
  :where(h6, .u-h6) {
    --heading--ff: var(--fdt-core-heading-h6-fontfamily);
    --heading--fs: clamp(var(--fdt-mobile-fontsize-3), 1rem + 0vw, var(--fdt-core-heading-h6-fontsize));
    --heading--lh: var(--fdt-core-heading-h6-lineheight);
    --heading--fw: var(--fdt-core-heading-h6-fontweight);
    --heading--ls: var(--fdt-core-heading-h6-letterspacing);
    --heading--color: var(--fdt-core-color-typography-heading-h6);
    --heading--mbe: var(
      --e-heading-h6-mbe,
      var(--fdt-core-spacing-3)
    );
    --heading--tt: var(--fdt-core-heading-h6-textcase);
  }
  @media screen and (max-width: 63.9375em) {
    .u-h2-until-tablet {
      --heading--ff: var(--fdt-core-heading-2-fontfamily);
      --heading--fs: clamp(var(--fdt-mobile-fontsize-7), 0.163rem + 2.286vw, var(--fdt-core-heading-h2-fontsize));
      --heading--lh: var(--fdt-core-heading-h2-lineheight);
      --heading--fw: var(--fdt-core-heading-h2-fontweight);
      --heading--ls: var(--fdt-core-heading-h2-letterspacing);
      --heading--color: var(--fdt-core-color-typography-heading-h2);
      --heading--mbe: var(--fdt-core-spacing-4);
      --heading--tt: var(--fdt-core-heading-h2-textcase);
    }
  }
}
@layer elements {
  :where(a) {
    display: var(--a--display, unset);
    color: var(--a--color, var(--fdt-semantic-color-foreground-active, currentColor));
    text-decoration: var(--a--text-deco, none);
    text-underline-offset: 5px;
  }
}
@layer elements {
  :where(blockquote) {
    position: relative;
    font-family: var(--fdt-semantic-typography-quote-fontfamily);
    font-size: var(--fdt-semantic-typography-quote-fontsize);
    line-height: var(--fdt-semantic-typography-quote-lineheight);
    letter-spacing: var(--fdt-semantic-typography-quote-letterspacing);
    font-weight: var(--fdt-semantic-typography-quote-fontweight);
    padding-block-end: var(--fdt-core-spacing-3);
    margin: 0px;
    text-transform: var(--fdt-semantic-typography-quote-textcase, none);
    color: var(--blockquote-quote-color, var(--fdt-core-color-typography-heading-h3));
  }
  :where(blockquote)::after {
    content: "";
    position: absolute;
    bottom: 0px;
    left: 0px;
    border-color: var(--blockquote-border-color, var(--fdt-semantic-color-border-primary));
    border-style: solid;
    border-width: 0px;
    border-block-end-width: 4px;
    width: var(--fdt-core-spacing-6);
    margin-block-start: var(--fdt-core-spacing-3);
  }
}
@layer elements {
  :where(img) {
    max-width: var(--img--max-width, 100%);
    height: var(--img--height, auto);
    opacity: var(--img--opacity, 1);
    filter: var(--img--filter, none);
    box-shadow: var(--img--box-shadow, none);
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    :where(img) {
      image-rendering: -webkit-optimize-contrast !important;
    }
  }
  :where(picture) {
    display: block;
    width: var(--picture--width, 100%);
    height: var(--picture--height, auto);
  }
  :where(video) {
    width: var(--video--width, 100%);
    height: var(--video--height, auto);
  }
  :where(figure) {
    max-width: 100%;
    width: 100%;
    height: auto;
  }
  :where(figcaption) {
    font-family: var(--fdt-core-heading-caption-fontfamily);
    font-size: var(--fdt-core-heading-caption-fontsize);
    line-height: var(--fdt-core-heading-caption-lineheight);
    font-weight: var(--fdt-core-heading-caption-fontweight);
    letter-spacing: var(--fdt-core-heading-caption-letterspacing);
    color: var(--figcaption--color, currentColor);
  }
  :where(svg),
  body main svg.a-svg {
    width: var(--svg--width, auto);
    height: var(--svg--height, unset);
    min-width: var(--svg--min-width, 12px);
    max-width: var(--svg--max-width, auto);
    max-height: var(--svg--max-height);
    fill: var(--svg--fill, currentColor);
    stroke: var(--svg--stroke);
    flex-shrink: var(--svg--shrink, 0);
  }
}
@layer elements {}
@layer elements {
  details {
    position: relative;
  }
  summary {
    list-style: none;
  }
  summary::-webkit-details-marker {
    display: none;
  }
}
@layer elements {
  hr {
    border-width: var(--divider--width) 0 0 0;
    border-color: var(--divider--color);
    border-style: var(--divider--style);
    opacity: var(--divider--opacity);
    width: 100%;
  }
}
@layer atoms {
  .a-scroll {
    --display: block;
  }
  .a-scroll::before, .a-scroll::after {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    height: 1px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.04);
    border-width: 0;
    box-shadow: var(--scroll--box-shadow, 0px 3px 5px var(--fdt-core-elevation-1-spread) var(--start--color, var(--fdt-core-elevation-1-color)), -1px -2px var(--fdt-core-elevation-1-blur) var(--fdt-core-elevation-1-spread) var(--end--color, var(--fdt-core-elevation-1-color)));
  }
  .a-scroll::before {
    content: var(--scroll-start, "");
    border-block-end-width: var(--fdt-semantic-borderwidth-default);
    top: 0px;
  }
  .a-scroll::after {
    content: var(--scroll-end, "");
    border-block-start-width: var(--fdt-semantic-borderwidth-default);
    bottom: 0px;
  }
  .a-scroll.at-start {
    --scroll-start: none;
    --start--color: transparent;
  }
  .a-scroll.at-end {
    --scroll-end: none;
    --end--color: transparent;
  }
  .a-scroll__start,
  .a-scroll__end {
    display: var(--display, none);
    width: 1px;
  }
  .a-scroll__start {
    margin-block-start: 2px;
  }
  .a-scroll__end {
    margin-block-end: 2px;
  }
  .a-scroll--horizontal {
    --scroll--box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.1);
  }
  .a-scroll--horizontal::before {
    width: 1px;
    height: calc(100% - var(--scroll-start--padding, 3px));
    border-block-end-width: 0;
    border-inline-end-width: var(--fdt-semantic-borderwidth-default);
    left: 0;
    top: 3px;
  }
  .a-scroll--horizontal::after {
    width: 1px;
    height: calc(100% - var(--scroll-start--padding, 3px));
    border-block-start-width: 0;
    border-inline-start-width: var(--fdt-semantic-borderwidth-default);
    left: auto;
    bottom: auto;
    top: 3px;
    right: 0;
  }
  @media screen and (max-width: 63.9375em) {
    .a-scroll--horizontal\@mob {
      --scroll--box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.1);
    }
    .a-scroll--horizontal\@mob::before {
      width: 1px;
      height: calc(100% - var(--scroll-start--padding, 3px));
      border-block-end-width: 0;
      border-inline-end-width: var(--fdt-semantic-borderwidth-default);
      left: 0;
      top: 3px;
    }
    .a-scroll--horizontal\@mob::after {
      width: 1px;
      height: calc(100% - var(--scroll-start--padding, 3px));
      border-block-start-width: 0;
      border-inline-start-width: var(--fdt-semantic-borderwidth-default);
      left: auto;
      bottom: auto;
      top: 3px;
      right: 0;
    }
  }
}
.a-scroll--h-gradient::before, .a-scroll--h-gradient::after {
  width: 60px;
  position: absolute;
  display: inline-block;
  height: calc(var(--fdt-button-sizing-minheight-normal) + 2px);
  background: linear-gradient(90deg, var(--inline-start--color, rgb(255, 255, 255)) 50%, rgba(255, 255, 255, 0) 118.18%);
  box-shadow: none;
  border-block-start-width: 0;
  pointer-events: none;
}
.a-scroll--h-gradient::before {
  left: var(--scroll-h-gradient-before--left, -1px);
}
.a-scroll--h-gradient::after {
  transform: rotate(-180deg);
  right: var(--scroll-h-gradient-before--right, -1px);
  left: auto;
}
.a-scroll--h-gradient .a-scroll__end,
.a-scroll--h-gradient .a-scroll__start {
  margin-block: 0;
}

@layer molecules {
  .m-rt {
    --link--lh: inherit;
  }
  .m-rt p,
  .m-rt ol,
  .m-rt ul {
    margin-block-end: var(--set-rt--mbe, var(--rt--mbe, calc(var(--fdt-core-fontsize-base) * 2))) !important;
  }
  .m-rt p:last-child,
  .m-rt ol:last-child,
  .m-rt ul:last-child {
    margin-block-end: 0 !important;
  }
  .m-rt ol,
  .m-rt ul {
    padding-inline-start: var(--fdt-core-spacing-4);
    display: inline-block;
    text-align: left;
  }
  .m-rt ol ul,
  .m-rt ol ol,
  .m-rt ul ul,
  .m-rt ul ol {
    display: block;
  }
  .m-rt li::marker {
    color: var(--list-marker--color, var(--fdt-semantic-color-foreground-primary));
  }
  .m-rt ol {
    counter-reset: li;
  }
  .m-rt ol li {
    counter-increment: li;
  }
  .m-rt ol li::marker {
    content: counter(li) ".  ";
  }
  .m-rt ul {
    list-style: var(--rt-ul--list-style, var(--theme-icon--bullet));
    filter: var(--list-marker--filter);
  }
  .m-rt sup {
    vertical-align: super;
    font-size: smaller;
  }
  .m-rt em {
    font-style: italic;
  }
  .m-rt strike {
    text-decoration: line-through;
  }
  .m-rt blockquote {
    margin-block-end: var(--fdt-core-spacing-5);
  }
  .m-rt[class*=u-bg-color] {
    padding: var(--fdt-core-spacing-6);
  }
}
@layer molecules {
  .m-installer {
    display: inline-flex;
    align-items: center;
    gap: 0 var(--fdt-core-spacing-2);
    color: var(--fdt-semantic-color-foreground-subtle);
  }
  .m-installer aside {
    line-height: 1;
  }
}
@layer molecules {
  .m-comp-header {
    --set-heading--mbe: 0;
    text-align: center;
    place-items: stretch center;
    padding-block-end: var(--fdt-core-spacing-4);
    margin-inline: auto;
    max-width: var(--comp-header--max-width, var(--container-small--width));
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--fdt-core-spacing-3) var(--fdt-core-spacing-2);
    font-family: var(--fdt-semantic-typography-intro-fontfamily);
    font-size: var(--fdt-semantic-typography-intro-fontsize);
    line-height: var(--fdt-semantic-typography-intro-lineheight);
    font-weight: var(--fdt-semantic-typography-intro-fontweight);
    letter-spacing: var(--fdt-semantic-typography-intro-letterspacing);
  }
  @media (--from-mob-s) {
    .m-comp-header {
      gap: var(--fdt-core-spacing-4) var(--fdt-core-spacing-2);
      padding-block-end: var(--fdt-core-spacing-6);
    }
  }
  .m-comp-footer {
    --btn--min-width: var(--comp-footer__btn--width);
    --btn--text-align: var(--comp-footer__btn--text-align);
    --btn--justify-content: var(--comp-footer__btn--jc);
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--fdt-core-spacing-4) var(--fdt-core-spacing-2);
    place-items: var(--comp-footer--place-items, center);
    margin-block-start: var(--comp-footer--mbs, var(--fdt-core-spacing-6));
  }
}
@layer utilities {
  @media screen and (max-width: 39.9375em) {
    .u-pb-2-until-mob {
      padding-block: var(--fdt-core-spacing-2) !important;
    }
    .u-pb-5-until-mob {
      padding-block: var(--fdt-core-spacing-5) !important;
    }
  }
  @media screen and (max-width: 63.9375em) {
    .u-pbe-3-until-tablet {
      padding-block-end: var(--fdt-core-spacing-3) !important;
    }
  }
  .u-m-0 {
    margin: 0 !important;
  }
  .u-mbe-0 {
    margin-block-end: 0 !important;
  }
  .u-mbs-0 {
    margin-block-start: 0 !important;
  }
  .u-mis-auto {
    margin-inline-start: auto !important;
  }
  .u-m-auto {
    margin: auto !important;
  }
  .u-p-0 {
    padding: 0 !important;
  }
  .u-pbe-0 {
    padding-block-end: 0 !important;
  }
  .u-mie-1 {
    margin-inline-end: var(--fdt-core-spacing-1) !important;
  }
  .u-mis-1 {
    margin-inline-start: var(--fdt-core-spacing-1) !important;
  }
  .u-mi-1 {
    margin-inline-start: var(--fdt-core-spacing-1) !important;
    margin-inline-end: var(--fdt-core-spacing-1) !important;
  }
  .u-mb-1 {
    margin-block-start: var(--fdt-core-spacing-1) !important;
    margin-block-end: var(--fdt-core-spacing-1) !important;
  }
  .u-mb-auto {
    margin-block: auto !important;
  }
  .u-mbs-1 {
    margin-block-start: var(--fdt-core-spacing-1) !important;
  }
  .u-mbe-1 {
    margin-block-end: var(--fdt-core-spacing-1) !important;
  }
  .u-p-1 {
    padding: var(--fdt-core-spacing-1) !important;
  }
  .u-pbs-1 {
    padding-block-start: var(--fdt-core-spacing-1) !important;
  }
  .u-pbe-1 {
    padding-block-end: var(--fdt-core-spacing-1) !important;
  }
  .u-pb-1 {
    padding-block-start: var(--fdt-core-spacing-1) !important;
    padding-block-end: var(--fdt-core-spacing-1) !important;
  }
  .u-pis-1 {
    padding-inline-start: var(--fdt-core-spacing-1) !important;
  }
  .u-pie-1 {
    padding-inline-end: var(--fdt-core-spacing-1) !important;
  }
  .u-pi-1 {
    padding-inline-start: var(--fdt-core-spacing-1) !important;
    padding-inline-end: var(--fdt-core-spacing-1) !important;
  }
  .u-gap-1 {
    gap: var(--fdt-core-spacing-1) !important;
  }
  .u-mie-2 {
    margin-inline-end: var(--fdt-core-spacing-2) !important;
  }
  .u-mis-2 {
    margin-inline-start: var(--fdt-core-spacing-2) !important;
  }
  .u-mi-2 {
    margin-inline-start: var(--fdt-core-spacing-2) !important;
    margin-inline-end: var(--fdt-core-spacing-2) !important;
  }
  .u-mb-2 {
    margin-block-start: var(--fdt-core-spacing-2) !important;
    margin-block-end: var(--fdt-core-spacing-2) !important;
  }
  .u-mb-auto {
    margin-block: auto !important;
  }
  .u-mbs-2 {
    margin-block-start: var(--fdt-core-spacing-2) !important;
  }
  .u-mbe-2 {
    margin-block-end: var(--fdt-core-spacing-2) !important;
  }
  .u-p-2 {
    padding: var(--fdt-core-spacing-2) !important;
  }
  .u-pbs-2 {
    padding-block-start: var(--fdt-core-spacing-2) !important;
  }
  .u-pbe-2 {
    padding-block-end: var(--fdt-core-spacing-2) !important;
  }
  .u-pb-2 {
    padding-block-start: var(--fdt-core-spacing-2) !important;
    padding-block-end: var(--fdt-core-spacing-2) !important;
  }
  .u-pis-2 {
    padding-inline-start: var(--fdt-core-spacing-2) !important;
  }
  .u-pie-2 {
    padding-inline-end: var(--fdt-core-spacing-2) !important;
  }
  .u-pi-2 {
    padding-inline-start: var(--fdt-core-spacing-2) !important;
    padding-inline-end: var(--fdt-core-spacing-2) !important;
  }
  .u-gap-2 {
    gap: var(--fdt-core-spacing-2) !important;
  }
  .u-mie-3 {
    margin-inline-end: var(--fdt-core-spacing-3) !important;
  }
  .u-mis-3 {
    margin-inline-start: var(--fdt-core-spacing-3) !important;
  }
  .u-mi-3 {
    margin-inline-start: var(--fdt-core-spacing-3) !important;
    margin-inline-end: var(--fdt-core-spacing-3) !important;
  }
  .u-mb-3 {
    margin-block-start: var(--fdt-core-spacing-3) !important;
    margin-block-end: var(--fdt-core-spacing-3) !important;
  }
  .u-mb-auto {
    margin-block: auto !important;
  }
  .u-mbs-3 {
    margin-block-start: var(--fdt-core-spacing-3) !important;
  }
  .u-mbe-3 {
    margin-block-end: var(--fdt-core-spacing-3) !important;
  }
  .u-p-3 {
    padding: var(--fdt-core-spacing-3) !important;
  }
  .u-pbs-3 {
    padding-block-start: var(--fdt-core-spacing-3) !important;
  }
  .u-pbe-3 {
    padding-block-end: var(--fdt-core-spacing-3) !important;
  }
  .u-pb-3 {
    padding-block-start: var(--fdt-core-spacing-3) !important;
    padding-block-end: var(--fdt-core-spacing-3) !important;
  }
  .u-pis-3 {
    padding-inline-start: var(--fdt-core-spacing-3) !important;
  }
  .u-pie-3 {
    padding-inline-end: var(--fdt-core-spacing-3) !important;
  }
  .u-pi-3 {
    padding-inline-start: var(--fdt-core-spacing-3) !important;
    padding-inline-end: var(--fdt-core-spacing-3) !important;
  }
  .u-gap-3 {
    gap: var(--fdt-core-spacing-3) !important;
  }
  .u-mie-4 {
    margin-inline-end: var(--fdt-core-spacing-4) !important;
  }
  .u-mis-4 {
    margin-inline-start: var(--fdt-core-spacing-4) !important;
  }
  .u-mi-4 {
    margin-inline-start: var(--fdt-core-spacing-4) !important;
    margin-inline-end: var(--fdt-core-spacing-4) !important;
  }
  .u-mb-4 {
    margin-block-start: var(--fdt-core-spacing-4) !important;
    margin-block-end: var(--fdt-core-spacing-4) !important;
  }
  .u-mb-auto {
    margin-block: auto !important;
  }
  .u-mbs-4 {
    margin-block-start: var(--fdt-core-spacing-4) !important;
  }
  .u-mbe-4 {
    margin-block-end: var(--fdt-core-spacing-4) !important;
  }
  .u-p-4 {
    padding: var(--fdt-core-spacing-4) !important;
  }
  .u-pbs-4 {
    padding-block-start: var(--fdt-core-spacing-4) !important;
  }
  .u-pbe-4 {
    padding-block-end: var(--fdt-core-spacing-4) !important;
  }
  .u-pb-4 {
    padding-block-start: var(--fdt-core-spacing-4) !important;
    padding-block-end: var(--fdt-core-spacing-4) !important;
  }
  .u-pis-4 {
    padding-inline-start: var(--fdt-core-spacing-4) !important;
  }
  .u-pie-4 {
    padding-inline-end: var(--fdt-core-spacing-4) !important;
  }
  .u-pi-4 {
    padding-inline-start: var(--fdt-core-spacing-4) !important;
    padding-inline-end: var(--fdt-core-spacing-4) !important;
  }
  .u-gap-4 {
    gap: var(--fdt-core-spacing-4) !important;
  }
  .u-mie-5 {
    margin-inline-end: var(--fdt-core-spacing-5) !important;
  }
  .u-mis-5 {
    margin-inline-start: var(--fdt-core-spacing-5) !important;
  }
  .u-mi-5 {
    margin-inline-start: var(--fdt-core-spacing-5) !important;
    margin-inline-end: var(--fdt-core-spacing-5) !important;
  }
  .u-mb-5 {
    margin-block-start: var(--fdt-core-spacing-5) !important;
    margin-block-end: var(--fdt-core-spacing-5) !important;
  }
  .u-mb-auto {
    margin-block: auto !important;
  }
  .u-mbs-5 {
    margin-block-start: var(--fdt-core-spacing-5) !important;
  }
  .u-mbe-5 {
    margin-block-end: var(--fdt-core-spacing-5) !important;
  }
  .u-p-5 {
    padding: var(--fdt-core-spacing-5) !important;
  }
  .u-pbs-5 {
    padding-block-start: var(--fdt-core-spacing-5) !important;
  }
  .u-pbe-5 {
    padding-block-end: var(--fdt-core-spacing-5) !important;
  }
  .u-pb-5 {
    padding-block-start: var(--fdt-core-spacing-5) !important;
    padding-block-end: var(--fdt-core-spacing-5) !important;
  }
  .u-pis-5 {
    padding-inline-start: var(--fdt-core-spacing-5) !important;
  }
  .u-pie-5 {
    padding-inline-end: var(--fdt-core-spacing-5) !important;
  }
  .u-pi-5 {
    padding-inline-start: var(--fdt-core-spacing-5) !important;
    padding-inline-end: var(--fdt-core-spacing-5) !important;
  }
  .u-gap-5 {
    gap: var(--fdt-core-spacing-5) !important;
  }
  .u-mie-6 {
    margin-inline-end: var(--fdt-core-spacing-6) !important;
  }
  .u-mis-6 {
    margin-inline-start: var(--fdt-core-spacing-6) !important;
  }
  .u-mi-6 {
    margin-inline-start: var(--fdt-core-spacing-6) !important;
    margin-inline-end: var(--fdt-core-spacing-6) !important;
  }
  .u-mb-6 {
    margin-block-start: var(--fdt-core-spacing-6) !important;
    margin-block-end: var(--fdt-core-spacing-6) !important;
  }
  .u-mb-auto {
    margin-block: auto !important;
  }
  .u-mbs-6 {
    margin-block-start: var(--fdt-core-spacing-6) !important;
  }
  .u-mbe-6 {
    margin-block-end: var(--fdt-core-spacing-6) !important;
  }
  .u-p-6 {
    padding: var(--fdt-core-spacing-6) !important;
  }
  .u-pbs-6 {
    padding-block-start: var(--fdt-core-spacing-6) !important;
  }
  .u-pbe-6 {
    padding-block-end: var(--fdt-core-spacing-6) !important;
  }
  .u-pb-6 {
    padding-block-start: var(--fdt-core-spacing-6) !important;
    padding-block-end: var(--fdt-core-spacing-6) !important;
  }
  .u-pis-6 {
    padding-inline-start: var(--fdt-core-spacing-6) !important;
  }
  .u-pie-6 {
    padding-inline-end: var(--fdt-core-spacing-6) !important;
  }
  .u-pi-6 {
    padding-inline-start: var(--fdt-core-spacing-6) !important;
    padding-inline-end: var(--fdt-core-spacing-6) !important;
  }
  .u-gap-6 {
    gap: var(--fdt-core-spacing-6) !important;
  }
  .u-mie-7 {
    margin-inline-end: var(--fdt-core-spacing-7) !important;
  }
  .u-mis-7 {
    margin-inline-start: var(--fdt-core-spacing-7) !important;
  }
  .u-mi-7 {
    margin-inline-start: var(--fdt-core-spacing-7) !important;
    margin-inline-end: var(--fdt-core-spacing-7) !important;
  }
  .u-mb-7 {
    margin-block-start: var(--fdt-core-spacing-7) !important;
    margin-block-end: var(--fdt-core-spacing-7) !important;
  }
  .u-mb-auto {
    margin-block: auto !important;
  }
  .u-mbs-7 {
    margin-block-start: var(--fdt-core-spacing-7) !important;
  }
  .u-mbe-7 {
    margin-block-end: var(--fdt-core-spacing-7) !important;
  }
  .u-p-7 {
    padding: var(--fdt-core-spacing-7) !important;
  }
  .u-pbs-7 {
    padding-block-start: var(--fdt-core-spacing-7) !important;
  }
  .u-pbe-7 {
    padding-block-end: var(--fdt-core-spacing-7) !important;
  }
  .u-pb-7 {
    padding-block-start: var(--fdt-core-spacing-7) !important;
    padding-block-end: var(--fdt-core-spacing-7) !important;
  }
  .u-pis-7 {
    padding-inline-start: var(--fdt-core-spacing-7) !important;
  }
  .u-pie-7 {
    padding-inline-end: var(--fdt-core-spacing-7) !important;
  }
  .u-pi-7 {
    padding-inline-start: var(--fdt-core-spacing-7) !important;
    padding-inline-end: var(--fdt-core-spacing-7) !important;
  }
  .u-gap-7 {
    gap: var(--fdt-core-spacing-7) !important;
  }
  .u-mie-8 {
    margin-inline-end: var(--fdt-core-spacing-8) !important;
  }
  .u-mis-8 {
    margin-inline-start: var(--fdt-core-spacing-8) !important;
  }
  .u-mi-8 {
    margin-inline-start: var(--fdt-core-spacing-8) !important;
    margin-inline-end: var(--fdt-core-spacing-8) !important;
  }
  .u-mb-8 {
    margin-block-start: var(--fdt-core-spacing-8) !important;
    margin-block-end: var(--fdt-core-spacing-8) !important;
  }
  .u-mb-auto {
    margin-block: auto !important;
  }
  .u-mbs-8 {
    margin-block-start: var(--fdt-core-spacing-8) !important;
  }
  .u-mbe-8 {
    margin-block-end: var(--fdt-core-spacing-8) !important;
  }
  .u-p-8 {
    padding: var(--fdt-core-spacing-8) !important;
  }
  .u-pbs-8 {
    padding-block-start: var(--fdt-core-spacing-8) !important;
  }
  .u-pbe-8 {
    padding-block-end: var(--fdt-core-spacing-8) !important;
  }
  .u-pb-8 {
    padding-block-start: var(--fdt-core-spacing-8) !important;
    padding-block-end: var(--fdt-core-spacing-8) !important;
  }
  .u-pis-8 {
    padding-inline-start: var(--fdt-core-spacing-8) !important;
  }
  .u-pie-8 {
    padding-inline-end: var(--fdt-core-spacing-8) !important;
  }
  .u-pi-8 {
    padding-inline-start: var(--fdt-core-spacing-8) !important;
    padding-inline-end: var(--fdt-core-spacing-8) !important;
  }
  .u-gap-8 {
    gap: var(--fdt-core-spacing-8) !important;
  }
  .u-mie-9 {
    margin-inline-end: var(--fdt-core-spacing-9) !important;
  }
  .u-mis-9 {
    margin-inline-start: var(--fdt-core-spacing-9) !important;
  }
  .u-mi-9 {
    margin-inline-start: var(--fdt-core-spacing-9) !important;
    margin-inline-end: var(--fdt-core-spacing-9) !important;
  }
  .u-mb-9 {
    margin-block-start: var(--fdt-core-spacing-9) !important;
    margin-block-end: var(--fdt-core-spacing-9) !important;
  }
  .u-mb-auto {
    margin-block: auto !important;
  }
  .u-mbs-9 {
    margin-block-start: var(--fdt-core-spacing-9) !important;
  }
  .u-mbe-9 {
    margin-block-end: var(--fdt-core-spacing-9) !important;
  }
  .u-p-9 {
    padding: var(--fdt-core-spacing-9) !important;
  }
  .u-pbs-9 {
    padding-block-start: var(--fdt-core-spacing-9) !important;
  }
  .u-pbe-9 {
    padding-block-end: var(--fdt-core-spacing-9) !important;
  }
  .u-pb-9 {
    padding-block-start: var(--fdt-core-spacing-9) !important;
    padding-block-end: var(--fdt-core-spacing-9) !important;
  }
  .u-pis-9 {
    padding-inline-start: var(--fdt-core-spacing-9) !important;
  }
  .u-pie-9 {
    padding-inline-end: var(--fdt-core-spacing-9) !important;
  }
  .u-pi-9 {
    padding-inline-start: var(--fdt-core-spacing-9) !important;
    padding-inline-end: var(--fdt-core-spacing-9) !important;
  }
  .u-gap-9 {
    gap: var(--fdt-core-spacing-9) !important;
  }
}
@layer utilities {
  [hidden],
  .u-hide {
    display: none !important;
  }
  @media screen and (max-width: 26.5em) {
    .u-hide-mobile {
      display: none !important;
    }
  }
  @media screen and (min-width: 26.5625em) {
    .u-hide-from-mobile {
      display: none !important;
    }
  }
  @media screen and (max-width: 39.9375em) {
    .u-hide-tablet {
      display: none !important;
    }
  }
  @media screen and (min-width: 40em) {
    .u-hide-from-tablet {
      display: none !important;
    }
  }
  @media screen and (max-width: 63.9375em) {
    .u-hide-desktop {
      display: none !important;
    }
  }
  @media screen and (min-width: 64em) {
    .u-hide-from-desktop {
      display: none !important;
    }
  }
  @media screen and (max-width: 79.9375em) {
    .u-hide-wide {
      display: none !important;
    }
  }
  @media screen and (min-width: 80em) {
    .u-hide-from-wide {
      display: none !important;
    }
  }
  .u-contents {
    display: contents !important;
  }
}
@layer utilities {
  .u-text-capitalize {
    text-transform: capitalize !important;
  }
  .u-text-0 {
    line-height: 0 !important;
  }
  .u-fontsize-0 {
    font-size: 0 !important;
  }
  .u-text-upper {
    text-transform: uppercase !important;
  }
  .u-text-base {
    --link--fs: var(--fdt-core-fontsize-base);
    --rt--mbe: calc(var(--fdt-core-fontsize-base) * 2);
    font-size: var(--fdt-core-fontsize-base);
    line-height: var(--fdt-core-lineheight-paragraph);
  }
  .u-text-small {
    --link--fs: var(--fdt-core-body-p-small-fontsize);
    --rt--mbe: calc(var(--fdt-core-body-p-small-fontsize) * 2);
    font-size: var(--fdt-core-body-p-small-fontsize)  !important;
    line-height: var(--fdt-core-body-p-small-lineheight)  !important;
    letter-spacing: var(--fdt-core-body-p-small-letterspacing)  !important;
  }
  .u-text-normal {
    --link--fs: var(--fdt-core-body-p-normal-fontsize);
    --rt--mbe: calc(var(--fdt-core-body-p-normal-fontsize) * 2);
    font-size: var(--fdt-core-body-p-normal-fontsize) !important;
    line-height: var(--fdt-core-body-p-normal-lineheight) !important;
    letter-spacing: var(--fdt-core-body-p-normal-letterspacing) !important;
  }
  .u-text-tiny {
    --link--fs: var(--fdt-core-body-p-tiny-fontsize);
    --rt--mbe: calc(var(--fdt-core-body-p-tiny-fontsize) * 2);
    font-size: var(--fdt-core-body-p-tiny-fontsize) !important;
    line-height: var(--fdt-core-body-p-tiny-lineheight) !important;
    letter-spacing: var(--fdt-core-body-p-tiny-letterspacing) !important;
  }
  .u-text-large {
    --link--fs: var(--fdt-core-body-p-large-fontsize);
    --rt--mbe: calc(var(--fdt-core-body-p-large-fontsize) * 2);
    font-size: var(--fdt-mobile-fontsize-4) !important;
    line-height: var(--fdt-core-body-p-large-lineheight) !important;
    letter-spacing: var(--fdt-core-body-p-large-letterspacing) !important;
  }
  @media screen and (min-width: 40em) {
    .u-text-large {
      font-size: var(--fdt-core-body-p-large-fontsize) !important;
    }
  }
  .u-text-description {
    --link--fs: var(--fdt-semantic-typography-description-fontsize);
    --rt--mbe: calc(var(--fdt-semantic-typography-description-fontsize) * 2);
    font-family: var(--fdt-semantic-typography-description-fontfamily);
    font-size: var(--fdt-mobile-fontsize-2) !important;
    line-height: var(--fdt-semantic-typography-description-lineheight) !important;
    font-weight: var(--fdt-semantic-typography-description-fontweight) !important;
    letter-spacing: var(--fdt-semantic-typography-description-letterspacing) !important;
  }
  @media screen and (min-width: 40em) {
    .u-text-description {
      font-size: var(--fdt-semantic-typography-description-fontsize) !important;
    }
  }
  .u-text-intro {
    --link--fs: var(--fdt-semantic-typography-intro-fontsize);
    --rt--mbe: calc(var(--fdt-semantic-typography-intro-fontsize) * 2);
    font-family: var(--fdt-semantic-typography-intro-fontfamily);
    font-size: var(--fdt-mobile-fontsize-4) !important;
    line-height: var(--fdt-semantic-typography-intro-lineheight) !important;
    font-weight: var(--fdt-semantic-typography-intro-fontweight) !important;
    letter-spacing: var(--fdt-semantic-typography-intro-letterspacing) !important;
  }
  @media screen and (min-width: 40em) {
    .u-text-intro {
      font-size: var(--fdt-semantic-typography-intro-fontsize) !important;
    }
  }
  .u-text-caption {
    font-family: var(--fdt-core-heading-caption-fontfamily);
    font-size: var(--fdt-core-heading-caption-fontsize);
    font-weight: var(--fdt-core-heading-caption-fontweight);
    line-height: var(--fdt-core-heading-caption-lineheight);
    letter-spacing: var(--fdt-core-heading-caption-letterspacing);
    margin-block-end: var(--txt-caption--mbe, var(--fdt-core-spacing-1));
    text-transform: var(--fdt-core-heading-caption-textcase);
  }
  .u-text-placeholder {
    font-family: var(--fdt-semantic-typography-placeholder-fontfamily);
    font-size: var(--fdt-semantic-typography-placeholder-fontsize);
    font-weight: var(--fdt-semantic-typography-placeholder-fontweight);
    line-height: var(--fdt-semantic-typography-placeholder-lineheight);
    letter-spacing: var(--fdt-semantic-typography-placeholder-letterspacing);
    margin-block-end: var(--txt-placeholder--mbe, var(--fdt-core-spacing-1));
  }
  .u-text-center {
    text-align: center;
  }
  .u-text-right {
    text-align: right;
  }
  .u-text-bold {
    font-weight: var(--fdt-core-fontweight-heavy);
  }
  .u-text-semibold {
    font-weight: var(--fdt-core-fontweight-semi-bold);
  }
  .u-label-large {
    font-family: var(--fdt-semantic-typography-label-large-fontfamily) !important;
    font-size: var(--fdt-semantic-typography-label-large-fontsize) !important;
    line-height: var(--fdt-semantic-typography-label-large-lineheight) !important;
    font-weight: var(--fdt-semantic-typography-label-large-fontweight) !important;
    letter-spacing: var(--fdt-semantic-typography-label-large-letterspacing) !important;
  }
  .u-label {
    font-family: var(--fdt-semantic-typography-label-fontfamily) !important;
    font-size: var(--fdt-semantic-typography-label-fontsize) !important;
    line-height: var(--fdt-semantic-typography-label-lineheight) !important;
    font-weight: var(--fdt-semantic-typography-label-fontweight) !important;
    letter-spacing: var(--fdt-semantic-typography-label-letterspacing) !important;
  }
  .u-label-small {
    font-family: var(--fdt-semantic-typography-label-small-fontfamily)  !important;
    font-size: var(--fdt-semantic-typography-label-small-fontsize)  !important;
    line-height: var(--fdt-semantic-typography-label-small-lineheight)  !important;
    font-weight: var(--fdt-semantic-typography-label-small-fontweight)  !important;
    letter-spacing: var(--fdt-semantic-typography-label-small-letterspacing)  !important;
  }
  .u-label-tiny {
    font-family: var(--fdt-semantic-typography-label-tiny-fontfamily) !important;
    font-size: var(--fdt-semantic-typography-label-tiny-fontsize) !important;
    line-height: var(--fdt-semantic-typography-label-tiny-lineheight) !important;
    font-weight: var(--fdt-semantic-typography-label-tiny-fontweight) !important;
    letter-spacing: var(--fdt-semantic-typography-label-tiny-letterspacing) !important;
  }
  .u-description {
    font-family: var(--fdt-semantic-typography-description-fontfamily) !important;
    font-size: var(--fdt-semantic-typography-description-fontsize) !important;
    line-height: var(--fdt-semantic-typography-description-lineheight) !important;
    font-weight: var(--fdt-semantic-typography-description-fontweight) !important;
    letter-spacing: var(--fdt-semantic-typography-description-letterspacing) !important;
  }
  .u-truncate-multi {
    overflow: hidden;
    display: var(--trunc-multi--display, -webkit-box);
    -webkit-line-clamp: var(--truncate-multi, 2);
    -webkit-box-orient: vertical;
  }
  @supports (-webkit-touch-callout: none) {
    .u-truncate-multi {
      max-height: calc(var(--truncate--lh, var(--fdt-core-body-p-lineheight)) * var(--truncate-multi, 2));
    }
  }
  .u-truncate-multi--3 {
    --truncate-multi: 3;
  }
  .u-truncate-multi--1 {
    --truncate-multi: 1;
  }
  .u-text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    display: block;
  }
  .u-white-space-nowrap {
    white-space: nowrap;
  }
}
@layer utilities {
  [class*=u-bg-color-]:not(.u-bg-color-default) {
    --skel-card--bgc: #ffffff;
  }
  .u-bg-color-warning,
  .u-bg-color-success,
  .u-bg-color-error,
  .u-bg-color-dark {
    container-name: var(--bg--secondary-container-name, button-secondary-inverted) var(--bg--tertiary-container-name, button-tertiary-inverted);
    container-type: inline-size;
    color: var(--fdt-semantic-color-foreground-inverted);
    --set-link--color: var(--fdt-semantic-color-foreground-inverted);
    --set-heading--color: var(--fdt-semantic-color-foreground-inverted);
    --component__header-h2--color: var(--fdt-semantic-color-foreground-inverted);
    --usp-card--color: var(--fdt-semantic-color-foreground-inverted);
    --usp-card-hover--bgc: rgba(255, 255, 255, 0.05);
    --usp-card__media--color: var(--fdt-semantic-color-foreground-inverted);
    --wc-collapse__icon--color: var(--fdt-semantic-color-foreground-inverted);
    --grid-center-before--bgc: rgba(255, 255, 255, 0.1);
    --list-marker--color: var(--fdt-semantic-color-foreground-inverted);
    --list-marker--filter: brightness(0) invert(1);
    --blockquote-border-color: var(--fdt-semantic-color-foreground-inverted);
    --m-cta__icon--fill: var(--fdt-core-color-accent-light-overlay);
  }
  .u-bg-color-default {
    --u-bg-color: var(--fdt-semantic-color-background-default);
    background-color: var(--fdt-semantic-color-background-default) !important;
  }
  .u-bg-color-dark {
    --u-bg-color: var(--fdt-core-color-accent-dark);
    background-color: var(--fdt-core-color-accent-dark) !important;
  }
  .u-bg-color-subtle {
    --scrollbar-foreground-color: var(--fdt-semantic-color-background-default);
    --u-bg-color: var(--fdt-semantic-color-background-primary-subtle);
    background-color: var(--fdt-semantic-color-background-primary-subtle) !important;
  }
  .u-bg-color-light {
    --scrollbar-foreground-color: var(--fdt-semantic-color-background-default);
    --u-bg-color: var(--fdt-semantic-color-background-accent-light);
    background-color: var(--fdt-semantic-color-background-accent-light) !important;
  }
  .u-bg-color-brand {
    --set-link--color: var(--fdt-semantic-color-foreground-on-brand);
    --set-heading--color: var(--fdt-semantic-color-foreground-on-brand);
    --fdt-button-color-primary-background: var(--fdt-button-color-primary-background-on-brand);
    --fdt-button-color-primary-background-hover: var(
        --fdt-button-color-primary-background-hover-on-brand
    );
    --fdt-button-color-primary-background-pressed: var(
        --fdt-button-color-primary-background-pressed-on-brand
    );
    --fdt-button-color-primary-text: var(--fdt-button-color-primary-text-on-brand);
    --fdt-button-color-primary-text-hover: var(--fdt-button-color-primary-text-hover-on-brand);
    --fdt-button-color-primary-text-pressed: var(
        --fdt-button-color-primary-text-pressed-on-brand
    );
    --fdt-button-color-secondary-background-hover: var(
        --fdt-button-color-secondary-background-hover-on-brand
    );
    --fdt-button-color-secondary-background-pressed: var(
        --fdt-button-color-secondary-background-pressed-on-brand
    );
    --fdt-button-color-secondary-foreground: var(
        --fdt-button-color-secondary-foreground-on-brand
    );
    --fdt-button-color-secondary-foreground-hover: var(
        --fdt-button-color-secondary-foreground-hover-on-brand
    );
    --fdt-button-color-secondary-foreground-pressed: var(
        --fdt-button-color-secondary-foreground-pressed-on-brand
    );
    --fdt-button-color-secondary-border: var(--fdt-button-color-secondary-border-on-brand);
    --fdt-button-color-secondary-border-hover: var(
        --fdt-button-color-secondary-border-hover-on-brand
    );
    --fdt-button-color-secondary-pressed-pressed: var(
        --fdt-button-color-secondary-border-pressed-on-brand
    );
    --u-bg-color: var(--fdt-semantic-color-background-primary);
    color: var(--fdt-semantic-color-foreground-on-brand) !important;
    background-color: var(--fdt-semantic-color-background-primary) !important;
  }
  .u-bg-color-primary-50 {
    background-color: var(--fdt-core-color-primary-50) !important;
  }
  .u-bg-color-primary-300 {
    background-color: var(--fdt-core-color-primary-300) !important;
  }
  .u-bg-color-primary-500 {
    --scrollbar-foreground-color: var(--fdt-semantic-color-background-default);
    background-color: var(--fdt-core-color-primary-500) !important;
  }
  .u-bg-color-error {
    color: var(--fdt-semantic-color-foreground-inverted) !important;
    background-color: var(--fdt-semantic-color-background-error) !important;
  }
  .u-bg-color-success {
    color: var(--fdt-semantic-color-foreground-inverted) !important;
    background-color: var(--fdt-semantic-color-background-success) !important;
  }
  .u-bg-color-warning {
    color: var(--fdt-semantic-color-foreground-inverted) !important;
    background-color: var(--fdt-semantic-color-background-warning) !important;
  }
  .u-bg-color-gradient {
    color: var(--fdt-semantic-color-foreground-inverted) !important;
    background: var(--fdt-core-color-gradient) !important;
  }
  .u-color-active {
    color: var(--fdt-semantic-color-foreground-active) !important;
  }
  .u-color-error {
    color: var(--fdt-semantic-color-foreground-error) !important;
  }
  .u-color-succes {
    color: var(--fdt-semantic-color-foreground-succes) !important;
  }
  .u-color-default {
    color: var(--fdt-semantic-color-foreground-default) !important;
  }
  .u-overlay-black::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: var(--overlay-black);
    opacity: var(--overlay-black--opacity, 1);
  }
  .u-color-inactive {
    color: var(--fdt-semantic-color-foreground-inactive) !important;
  }
  .u-color-subtle {
    color: var(--fdt-semantic-color-foreground-subtle) !important;
  }
  .u-fill-active {
    color: var(--fdt-semantic-color-foreground-active) !important;
  }
  .u-fill-primary-subtle {
    fill: var(--fdt-semantic-color-background-primary-subtle) !important;
  }
  .u-fill-primary {
    fill: var(--fdt-semantic-color-background-primary) !important;
  }
  .u-fill-primary-light {
    fill: var(--fdt-semantic-color-background-primary-light) !important;
  }
}
@layer utilities {
  .u-w-auto {
    width: auto !important;
  }
  .u-w-100 {
    width: 100% !important;
  }
  .u-w-60 {
    width: 60% !important;
  }
  .u-w-50 {
    width: 50% !important;
  }
  .u-h-100 {
    height: 100% !important;
  }
  .u-vh-100 {
    height: var(--view-height-max) !important;
    height: -webkit-fill-available !important;
  }
  .u-w-max-small {
    max-width: var(--container-small--width) !important;
  }
  .u-w-max-tiny {
    max-width: var(--container-min--width) !important;
  }
}
@layer utilities {
  .u-icon-micro {
    --spinner--icon-width: var(--fdt-core-size-icon-micro);
    width: var(--fdt-core-size-icon-micro);
    height: var(--fdt-core-size-icon-micro);
  }
  .u-icon-tiny {
    --spinner--icon-width: var(--fdt-core-size-icon-tiny);
    width: var(--fdt-core-size-icon-tiny);
    height: var(--fdt-core-size-icon-tiny);
  }
  .u-icon-small {
    --spinner--icon-width: var(--fdt-core-size-icon-small);
    width: var(--fdt-core-size-icon-small);
    height: var(--fdt-core-size-icon-small);
  }
  .u-icon-normal {
    --spinner--icon-width: var(--fdt-core-size-icon-normal);
    width: var(--fdt-core-size-icon-normal);
    height: var(--fdt-core-size-icon-normal);
  }
  .u-icon-large {
    --spinner--icon-width: var(--fdt-core-size-icon-large);
    width: var(--fdt-core-size-icon-large);
    height: var(--fdt-core-size-icon-large);
  }
  .u-icon-display {
    --spinner--icon-width: var(--fdt-core-size-icon-display);
    width: var(--fdt-core-size-icon-display);
    height: var(--fdt-core-size-icon-display);
  }
  .u-icon-backdrop {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--fdt-semantic-color-background-primary-subtle);
    width: var(--fdt-core-size-icon-display);
    height: var(--fdt-core-size-icon-display);
    border-radius: var(--fdt-core-borderradius-circle);
  }
}
@layer utilities {
  .u-scroll {
    max-height: var(--scrollbar--max-height, 100%);
    overflow-y: var(--scrollbar--overflow-y, auto);
    overflow-x: var(--scrollbar--overflow-x, hidden);
  }
  @supports (-moz-appearance: none) {
    .u-scroll {
      scrollbar-width: thin;
      scrollbar-color: var(--scrollbar-foreground-color) var(--scrollbar-background-color);
    }
  }
  .u-scroll::-webkit-scrollbar {
    width: var(--scrollbar-size);
    height: var(--scrollbar-size);
  }
  .u-scroll::-webkit-scrollbar-button {
    display: none;
  }
  .u-scroll::-webkit-scrollbar-thumb {
    border-radius: var(--scrollbar-border-radius);
    background-color: var(--scrollbar-foreground-color);
    background-clip: padding-box;
  }
  .u-scroll::-webkit-scrollbar-track {
    border-radius: var(--scrollbar-border-radius);
    background: var(--scrollbar-background-color);
  }
  .u-scroll-adjust {
    max-height: var(--scrollbar--max-height, 100%);
    overflow-y: var(--scrollbar--overflow-y, auto);
    overflow-x: var(--scrollbar--overflow-x, hidden);
    margin-inline-start: calc(100vw - 100%);
  }
  @supports (-moz-appearance: none) {
    .u-scroll-adjust {
      scrollbar-width: thin;
      scrollbar-color: var(--scrollbar-foreground-color) var(--scrollbar-background-color);
    }
  }
  .u-scroll-adjust::-webkit-scrollbar {
    width: var(--scrollbar-size);
    height: var(--scrollbar-size);
  }
  .u-scroll-adjust::-webkit-scrollbar-button {
    display: none;
  }
  .u-scroll-adjust::-webkit-scrollbar-thumb {
    border-radius: var(--scrollbar-border-radius);
    background-color: var(--scrollbar-foreground-color);
    background-clip: padding-box;
  }
  .u-scroll-adjust::-webkit-scrollbar-track {
    border-radius: var(--scrollbar-border-radius);
    background: var(--scrollbar-background-color);
  }
  .u-scroll-none {
    scrollbar-width: none; /* Firefox */
  }
  .u-scroll-none::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
}
@layer utilities {
  .u-op-normal {
    opacity: var(--fdt-core-opacity-normal) !important;
  }
  .u-op-soft {
    opacity: var(--fdt-core-opacity-soft) !important;
  }
  .u-op-hard {
    opacity: var(--fdt-core-opacity-hard) !important;
  }
}
@layer utilities {
  .u-sr {
    position: absolute !important;
    margin: -1px !important;
    border: 0 !important;
    padding: 0 !important;
    width: 1px !important;
    height: 1px !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    clip: rect(0 0 0 0) !important;
    clip-path: inset(50%) !important;
  }
  .u-cursor-pointer {
    cursor: pointer;
  }
  .u-cursor-pointer--20 {
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
}
[is-loading-disabled] {
  position: relative;
}
[is-loading-disabled]::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 1;
  cursor: progress;
}
[is-loading-disabled]:has(.o-skel__item) {
  pointer-events: auto;
}
[is-loading-disabled]:has(.o-skel__item)::after {
  content: none;
}

.u-spinner:after {
  content: "";
  display: inline-block;
  position: relative;
  width: var(--spinner--icon-width);
  height: var(--spinner--icon-width);
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: var(--spinner__is-loading--color, var(--fdt-semantic-color-foreground-inactive));
  border-bottom-color: var(--spinner__is-loading--color, var(--fdt-semantic-color-foreground-inactive));
  animation: btnSpinner 0.8s ease infinite;
}

.u-js-center {
  justify-self: center;
}

@layer utilities {
  .u-pos-relative {
    position: relative;
  }
}
@layer utilities {
  .u-overlay::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
}
.u-zindex-one {
  z-index: 1;
}

.z-2 {
  z-index: 2;
}

.flex-grow {
  flex-grow: 1;
}

.flex-auto {
  flex: 1 1 auto;
}

.flex-1 {
  flex: 1;
}

.w-auto {
  width: auto;
}

.o-skel {
  cursor: progress;
  --skel--bgc: #f9fafb;
}
.o-skel[aria-hidden=true] {
  display: none;
}

.o-skel--subtle-bg {
  background: var(--fdt-semantic-color-background-subtle);
}

.o-skel__mq-reducing-grid {
  display: flex;
  gap: var(--fdt-core-spacing-3);
  justify-content: center;
}
@media screen and (max-width: 39.9375em) {
  .o-skel__mq-reducing-grid {
    width: calc(100% + var(--container--spacing));
  }
}
.o-skel__mq-reducing-grid > * {
  flex-basis: 25%;
}
@media screen and (max-width: 79.9375em) {
  .o-skel__mq-reducing-grid > * {
    flex-basis: 25%;
  }
  .o-skel__mq-reducing-grid > *:nth-child(1n+5) {
    display: none;
  }
}
@media screen and (max-width: 63.9375em) {
  .o-skel__mq-reducing-grid > * {
    flex-basis: 33%;
  }
  .o-skel__mq-reducing-grid > *:nth-child(1n+4) {
    display: none;
  }
}
@media screen and (max-width: 39.9375em) {
  .o-skel__mq-reducing-grid > * {
    min-width: var(--wc-slider-columns-mob--width);
    max-width: var(--wc-slider-columns-mob--width);
  }
  .o-skel__mq-reducing-grid > *:nth-child(1n+3) {
    display: none;
  }
}
@media screen and (max-width: 26.5em) {
  .o-skel__mq-reducing-grid > * {
    min-width: var(--wc-slider-columns-mob-s--width, var(--wc-slider-columns-mob--width));
    max-width: var(--wc-slider-columns-mob-s--width, var(--wc-slider-columns-mob--width));
  }
}

.o-skel__item {
  min-height: var(--skel-item--min-height, 5px);
  max-width: var(--set-skel--max--width, var(--skel--max-width));
  width: var(--set-skel--width, var(--skel--width));
  background: linear-gradient(to right, rgba(194, 208, 214, 0.3) 8%, rgba(194, 208, 214, 0.4) 18%, rgba(194, 208, 214, 0.3) 33%);
  background-size: 800px 100px;
}
@media (prefers-reduced-motion: no-preference) {
  .o-skel__item {
    animation: skel-loading 2s linear infinite alternate;
  }
}
.o-skel__item.u-h1 {
  --skel--width: 100%;
  --skel--max-width: 500px;
}
.o-skel__item.u-h2 {
  --skel--width: 100%;
  --skel--max-width: 400px;
}
.o-skel__item.u-h3 {
  --skel--width: 100%;
  --skel--max-width: 300px;
}
.o-skel__item.u-h4 {
  --skel--width: 100%;
  --skel--max-width: 250px;
}
.o-skel__item.u-h5 {
  --skel--width: 100%;
  --skel--max-width: 200px;
}
.o-skel__item.u-h6 {
  --skel--width: 100%;
  --skel--max-width: 150px;
}
.o-skel__item.a-btn {
  --skel--max-width: var(--skel-btn--max-width, 150px);
  width: var(--skel-btn--width, 120px);
  flex-shrink: 0;
  cursor: progress;
}
.o-skel__item.a-btn--icon {
  width: auto !important;
  min-width: var(--fdt-button-sizing-minheight-normal);
}

.o-skel__item--ultra-tiny {
  line-height: 0.9;
}

.o-skel__item--third-width {
  --skel--max-width: 33%;
}

.o-skel__item--full-width {
  --set-skel--width: 100%;
  --skel-btn--max-width: 100%;
  --skel-btn--width: 100%;
}

.o-skel__paragraph {
  --skel--max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--fdt-core-spacing-2);
  width: 100%;
}
.o-skel__paragraph > :nth-child(2) {
  --skel--max-width: 60%;
}
.o-skel__paragraph > :nth-child(3) {
  --skel--max-width: 80%;
}
.o-skel__paragraph > :nth-child(4) {
  --skel--max-width: 30%;
}

.o-skel__image--full {
  width: 100%;
  height: 100%;
}

.o-skel__input {
  --skel-item--min-height: 20px;
  --skel--width: 110px;
  display: flex;
  flex-direction: column;
  gap: var(--fdt-core-spacing-1);
  line-height: 0px;
  max-width: var(--skel-input--max-width);
}
.o-skel__input > :last-child {
  min-height: var(--field--min-height);
  border: var(--field-input--bw, var(--fdt-semantic-borderwidth-default)) solid var(--field-input--bc, var(--fdt-semantic-color-border-subtle));
  border-radius: var(--fdt-semantic-borderradius-field);
}
.o-skel__input--checkbox, .o-skel__input--radio {
  display: flex;
  flex-direction: row;
  gap: var(--fdt-core-spacing-2);
}
.o-skel__input--checkbox > :first-child, .o-skel__input--radio > :first-child {
  border-radius: var(--fdt-semantic-borderradius-radio);
  width: var(--fdt-semantic-size-radio);
  height: var(--fdt-semantic-size-radio);
  flex-shrink: 0;
  border: var(--field-input--bw, var(--fdt-semantic-borderwidth-default)) solid var(--field-input--bc, var(--fdt-semantic-color-border-subtle));
}
.o-skel__input--checkbox > :last-child, .o-skel__input--radio > :last-child {
  flex-shrink: 0;
  border: none;
  min-height: auto;
}
.o-skel__input--checkbox > :first-child {
  border-radius: var(--fdt-semantic-borderradius-field);
}
.o-skel__input--textarea > :last-child {
  min-height: 136px;
}

.o-skel-card {
  cursor: progress;
  position: relative;
  display: var(--skel-card--display, grid);
  grid-template-rows: 1fr;
  grid-template-areas: "body";
  gap: var(--card--gap, var(--fdt-core-spacing-3));
  background-color: var(--skel-card--bgc, var(--skel--bgc));
  min-height: var(--skel-card--min-height);
  box-shadow: var(--skel-card--box-shadow);
  border: var(--skel-card--border);
  padding: var(--skel-card--padding);
}
.o-skel-card.hasbg {
  min-height: var(--skel-card-bg--min-height);
  --skel-card--border: none;
}
.o-skel-card:has(.o-skel-card__media) {
  grid-template-areas: var(--skel-card__has-media--gta, "media" "body");
  grid-template-columns: var(--skel-card__has-media--gtc);
  grid-template-rows: var(--skel-card__has-media--gtr, auto 1fr);
}
.o-skel-card:has(.o-skel-card__media) .o-skel-card__body {
  padding: var(--skel-card__body-has-media--padding, 0 var(--fdt-core-spacing-3) var(--fdt-core-spacing-4));
}
.o-skel-card__media {
  grid-area: media;
  margin: var(--skel-media--margin);
  padding: 0;
}
.o-skel-card__body {
  --fdt-core-body-p-tiny-lineheight: 1;
  grid-area: body;
  display: flex;
  flex-direction: column;
  gap: var(--fdt-core-spacing-3);
  padding: var(--fdt-core-spacing-3) var(--fdt-core-spacing-4);
  width: 100%;
}
.o-skel-card__body::after {
  content: none;
}

.o-skel-card--h {
  --card__body--pbe: 0;
  --skel--width: 100%;
  box-shadow: none;
  border: none;
}
.o-skel-card--h .o-skel-card__body {
  padding: var(--fdt-core-spacing-2) var(--fdt-core-spacing-3);
}
.o-skel-card--h[class*=u-p] {
  --skel-card-body--padding: 0;
}
.o-skel-card--h:has(.o-skel-card__media) {
  grid-template-columns: var(--set-skel-card-media--width, var(--skel-card-media--width, minmax(100px, 30%))) 1fr;
  grid-template-areas: "media body";
  grid-template-rows: 1fr;
}
.o-skel-card--h:has(.o-skel-card__media) .o-skel-card__body {
  padding: var(--skel-card-body--padding, var(--fdt-core-spacing-3) var(--fdt-core-spacing-3) var(--fdt-core-spacing-2) 0);
}

.o-skel-bgc {
  background-color: var(--skel--bgc);
}

.o-skel-box {
  --skel-card--padding: var(--fdt-core-spacing-3);
  --skel-card-body--padding: 0;
  border: 1px solid var(--fdt-semantic-color-border-subtle);
  gap: var(--fdt-core-spacing-3);
  border-radius: var(--fdt-semantic-borderradius-card);
}
.o-skel-box > header {
  --set-heading--mbe: var(--fdt-core-spacing-2);
  --set-skel--max--width: 150px;
  background-color: var(--skel--bgc);
  padding: var(--fdt-core-spacing-4) var(--fdt-core-spacing-3) var(--fdt-core-spacing-3);
}
.o-skel-box.o-skel-bgc {
  --skel-card--bgc: var(--fdt-semantic-color-background-default);
}

@keyframes skel-loading {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
@layer objects {
  .o-main-sidebar {
    --container--first-column: 0;
    display: grid;
    grid-template-columns: var(--main-sidebar--gtc, minmax(0, 1fr));
    grid-template-areas: "content" "sidebar";
    justify-content: stretch;
    align-content: stretch;
  }
  @media screen and (min-width: 40em) {
    .o-main-sidebar {
      grid-template-columns: 70px minmax(0, 1fr);
      grid-template-areas: "sidebar content";
    }
  }
  @media screen and (min-width: 64em) {
    .o-main-sidebar {
      --container--spacing: var(--fdt-core-spacing-5);
      --container-full-width--spacing: var(--fdt-core-spacing-5);
      --max-col-grid__gap: var(--fdt-core-spacing-3);
      grid-template-columns: 200px minmax(0, 1fr);
    }
  }
  .o-main-sidebar__aside {
    grid-area: sidebar;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
  }
  .o-main-sidebar__content {
    grid-area: content;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
}
@layer settings {
  :root {
    --container--spacing: var(--fdt-core-spacing-3);
    --container-full-width--spacing: 0px;
    --container--width: 100%;
    --container-max--width: 1600px;
    --container-website--width: 1200px;
    --container-small--width: 800px;
    --container-min--width: 600px;
    --wrapper--mimic-spacing: max(
      calc((100vw - var(--container--width)) / 2),
      var(--container--spacing)
    );
    --wrapper--mimic-spacing--small: max(
      calc((100vw - var(--container-small--width)) / 2),
      var(--container--spacing)
    );
    --wrapper--mimic-spacing--min: max(
      calc((100vw - var(--container-min--width)) / 2),
      var(--container--spacing)
    );
    --wrapper--mimic-spacing--website: max(
      calc((100vw - var(--container-website--width)) / 2),
      var(--container--spacing)
    );
    --wrapper--mimic-spacing--max: max(
      calc((100vw - var(--container-max--width)) / 2),
      var(--container--spacing)
    );
  }
  @media screen and (min-width: 40em) {
    :root {
      --container--spacing: var(--fdt-core-spacing-4);
    }
  }
  @media screen and (min-width: 64em) {
    :root {
      --container--spacing: var(--fdt-core-spacing-5);
    }
  }
  @media screen and (min-width: 80em) {
    :root {
      --container--spacing: var(--fdt-core-spacing-9);
    }
  }
}
@layer objects {
  .o-container {
    display: grid;
    column-gap: var(--container--spacing);
    grid-template-columns: var(--container--template-columns, var(--container--first-column, minmax(0, 1fr)) min(var(--container--width), 100% - 2 * var(--container--spacing)) minmax(0, 1fr));
    margin-block-end: var(--container--mbe, var(--fdt-core-spacing-9));
  }
  .o-container > * {
    grid-column: 2;
  }
  .o-container.has-bgi, .o-container[class*=u-bg-] {
    padding-block-start: var(--fdt-core-spacing-9);
    padding-block-end: var(--fdt-core-spacing-9);
  }
  .o-container.has-bgi {
    background-image: var(--container-bgi);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .o-container--full-width {
    --container--spacing: var(--container-full-width--spacing);
  }
  .o-container--full-width > * {
    grid-column: 1/-1;
  }
  .o-container--max-width {
    --container--width: var(--container-max--width);
  }
  .o-container--website-width {
    --container--width: var(--container-website--width);
  }
  .o-container--small-width {
    --container--width: var(--container-small--width);
  }
  .o-container--min-width {
    --container--width: var(--container-min--width);
  }
}
@layer objects {
  .o-fit {
    object-fit: cover;
    object-position: center center;
    font-family: "object-fit: cover;object-position: center center;";
    height: 100%;
    width: 100%;
  }
  .o-fit--contain {
    object-fit: contain;
    font-family: "object-fit: contain;object-position: center center;";
  }
  .o-fit--bottom {
    object-position: center bottom;
    font-family: "object-fit: cover;object-position: center bottom;";
  }
}
@layer objects {
  .o-ra {
    line-height: 0;
    --ra--h: 1;
    --ra--w: 1;
    aspect-ratio: 1/1;
  }
  @supports not (aspect-ratio: 1/1) {
    .o-ra::before {
      float: left;
      padding-top: calc(100% * var(--ra--h) / var(--ra--w));
      content: "";
    }
    .o-ra::after {
      display: block;
      content: "";
      clear: both;
    }
  }
  .o-ra--21\/9 {
    --ra--w: 21;
    --ra--h: 9;
    aspect-ratio: 21/9;
  }
  .o-ra--9\/21 {
    --ra--w: 9;
    --ra--h: 21;
    aspect-ratio: 9/21;
  }
  .o-ra--16\/9 {
    --ra--w: 16;
    --ra--h: 9;
    aspect-ratio: 16/9;
  }
  .o-ra--9\/16 {
    --ra--w: 9;
    --ra--h: 16;
    aspect-ratio: 9/16;
  }
  .o-ra--2\/1 {
    --ra--w: 2;
    --ra--h: 1;
    aspect-ratio: 2/1;
  }
  .o-ra--1\/2 {
    --ra--w: 1;
    --ra--h: 2;
    aspect-ratio: 1/2;
  }
  .o-ra--2\/3 {
    --ra--w: 2;
    --ra--h: 3;
    aspect-ratio: 2/3;
  }
  .o-ra--3\/2 {
    --ra--w: 3;
    --ra--h: 2;
    aspect-ratio: 3/2;
  }
  .o-ra--4\/3 {
    --ra--w: 4;
    --ra--h: 3;
    aspect-ratio: 4/3;
  }
  .o-ra--3\/4 {
    --ra--w: 3;
    --ra--h: 4;
    aspect-ratio: 3/4;
  }
  .o-ra--3\/1 {
    --ra--w: 3;
    --ra--h: 1;
    aspect-ratio: 3/1;
  }
  .o-ra--6\/1 {
    --ra--w: 6;
    --ra--h: 1;
    aspect-ratio: 6/1;
  }
  @media screen and (min-width: 64em) {
    .o-ra--2\/3\@tablet {
      --ra--w: 2;
      --ra--h: 3;
      aspect-ratio: 2/3;
    }
  }
  @media screen and (min-width: 80em) {
    .o-ra--2\/3\@desktop {
      --ra--w: 2;
      --ra--h: 3;
      aspect-ratio: 2/3;
    }
  }
}
@layer objects {
  .o-flex {
    display: flex;
  }
  .o-flex--inline {
    display: inline-flex;
    width: auto;
  }
  .o-flex--row {
    flex-direction: row;
  }
  .o-flex--column {
    flex-direction: column;
  }
  .o-flex--row-reverse {
    flex-direction: row-reverse;
  }
  .o-flex--column-reverse {
    flex-direction: column-reverse;
  }
  .o-flex--wrap {
    flex-wrap: wrap;
  }
  .o-flex--nowrap {
    flex-wrap: nowrap;
  }
  .o-flex--wrap-reverse {
    flex-wrap: wrap-reverse;
  }
  .o-flex__child--fill {
    flex: 1 1 auto;
  }
  .o-flex__child--grow-0 {
    flex-grow: 0;
  }
  .o-flex__child--grow-1 {
    flex-grow: 1;
  }
  .o-flex__child--shrink-0 {
    flex-shrink: 0;
  }
  .o-flex__child--shrink-1 {
    flex-shrink: 1;
  }
  .o-flex__child--align-self-start {
    align-self: flex-start;
  }
  .o-flex__child--align-self-end {
    align-self: flex-end;
  }
  .o-flex__child--align-self-stretch {
    align-self: stretch;
  }
  .o-flex--jc-start {
    justify-content: flex-start;
  }
  .o-flex--jc-end {
    justify-content: flex-end;
  }
  .o-flex--jc-center {
    justify-content: center;
  }
  .o-flex--jc-between {
    justify-content: space-between;
  }
  .o-flex--jc-around {
    justify-content: space-around;
  }
  .o-flex--ai-start {
    align-items: flex-start;
  }
  .o-flex--ai-end {
    align-items: flex-end;
  }
  .o-flex--ai-center {
    align-items: center;
  }
  .o-flex--ai-baseline {
    align-items: baseline;
  }
  .o-flex--ai-stretch {
    align-items: stretch;
  }
  .o-flex--ac-start {
    align-content: flex-start;
  }
  .o-flex--ac-end {
    align-content: flex-end;
  }
  .o-flex--ac-center {
    align-content: center;
  }
  .o-flex--ac-between {
    align-content: space-between;
  }
  .o-flex--ac-around {
    align-content: space-around;
  }
  .o-flex--ac-stretch {
    align-content: stretch;
  }
}
@layer objects {
  .o-max-col-grid {
    --grid-layout-gap: var(--max-col-grid__gap, var(--fdt-core-spacing-4));
    --grid-column-count: var(--set-max-col-grid__count, var(--max-col-grid__count, 8));
    --grid-item--min-width: var(--max-col-grid__width, 215px);
    --gap-count: calc(var(--grid-column-count) - 1);
    --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
    --grid-item--max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));
    display: grid;
    grid-template-columns: repeat(var(--grid-item--auto-fill, auto-fill), minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr));
    gap: var(--grid-layout-gap);
    place-items: var(--max-col-grid__pi, stretch);
  }
  .o-max-col-grid--auto-fit {
    --grid-item--auto-fill: auto-fit;
  }
  .o-max-col-grid--center-v {
    --max-col-grid__pi: center stretch;
  }
  .o-max-col-grid--1 {
    --max-col-grid__count: 1;
  }
  .o-max-col-grid--2 {
    --max-col-grid__count: 2;
  }
  .o-max-col-grid--3 {
    --max-col-grid__count: 3;
  }
  .o-max-col-grid--4 {
    --max-col-grid__count: 4;
  }
  .o-max-col-grid--5 {
    --max-col-grid__count: 5;
    --max-col-grid__width: 150px;
  }
  .o-max-col-grid--6 {
    --max-col-grid__count: 6;
    --max-col-grid__width: 120px;
  }
  .o-max-col-grid--7 {
    --max-col-grid__count: 7;
    --max-col-grid__width: 100px;
  }
  .o-max-col-grid--8 {
    --max-col-grid__count: 8;
    --max-col-grid__width: 80px;
  }
  .o-max-col-grid--min-width-default {
    --max-col-grid__width: 1px;
  }
  .o-max-col-grid-gap--none {
    --max-col-grid__gap: 0px;
  }
}
@layer objects {
  .o-grid-repeat {
    display: grid;
    grid-template-columns: repeat(var(--grid--count, 1), minmax(0, 1fr));
    grid-gap: var(--grid--gap, var(--fdt-core-spacing-4));
    place-items: var(--max-col-grid__pi, stretch);
  }
  @media screen and (min-width: 40em) {
    .o-grid-repeat {
      --grid--count: 3;
    }
  }
  .o-grid-repeat-gap--none {
    --grid--gap: 0px;
  }
  .o-grid-repeat-gap--center-v {
    --max-col-grid__pi: center stretch;
  }
  @media screen and (min-width: 40em) {
    .o-grid-repeat-gap-tablet--center {
      --max-col-grid__pi: center;
    }
    .o-grid-repeat--2 {
      --grid--count: 2;
    }
    .o-grid-repeat--4 {
      --grid--count: 2;
    }
    .o-grid-repeat--5 {
      --grid--count: var(--grid-repeat-5-mob--count, 2);
    }
    .o-grid-repeat--6 {
      --grid--count: 3;
    }
  }
  @media screen and (min-width: 64em) {
    .o-grid-repeat--4 {
      --grid--count: 4;
    }
    .o-grid-repeat--5 {
      --grid--count: 5;
    }
    .o-grid-repeat--6 {
      --grid--count: 6;
    }
  }
}
@layer objects {
  .o-span-2 {
    grid-column: span 2;
  }
  .o-span-3 {
    grid-column: span 3;
  }
  @media screen and (min-width: 40em) {
    .o-span-2-frm-mob {
      grid-column: span 2;
    }
    .o-span-3-frm-mob {
      grid-column: span 3;
    }
  }
  @media screen and (min-width: 64em) {
    .o-span-2-frm-tablet {
      grid-column: span 2;
    }
    .o-span-3-frm-tablet {
      grid-column: span 3;
    }
  }
}
@layer objects {
  .o-gap-0 {
    gap: 0;
  }
  .o-gap-1 {
    gap: var(--fdt-core-spacing-1);
  }
  .o-gap-2 {
    gap: var(--fdt-core-spacing-2);
  }
  .o-gap-3 {
    gap: var(--fdt-core-spacing-3);
  }
  .o-gap-4 {
    gap: var(--fdt-core-spacing-4);
  }
  .o-gap-5 {
    gap: var(--fdt-core-spacing-5);
  }
  .o-gap-6 {
    gap: var(--fdt-core-spacing-6);
  }
  .o-gap-7 {
    gap: var(--fdt-core-spacing-7);
  }
  .o-gap-8 {
    gap: var(--fdt-core-spacing-8);
  }
  .o-gap-9 {
    gap: var(--fdt-core-spacing-9);
  }
  .o-gap-row-3 {
    row-gap: var(--fdt-core-spacing-3);
  }
  .o-gap-row-4 {
    row-gap: var(--fdt-core-spacing-4);
  }
  .o-gap-row-9 {
    row-gap: var(--fdt-core-spacing-9);
  }
  .o-gap-row-none {
    row-gap: 0;
  }
  @media screen and (min-width: 40em) {
    .o-gap-tablet-9 {
      gap: var(--fdt-core-spacing-9);
    }
  }
}
@layer objects {
  .o-link-overlay {
    --a--color: currentColor;
    display: contents;
    position: unset !important;
    transition: background-color 0.3s ease-in-out;
  }
  .o-link-overlay::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: var(--link-overlay--zindex, 1);
  }
  .o-link-overlay:hover::after {
    cursor: pointer;
  }
  .o-link-overlay:focus-visible::after {
    outline: var(--fdt-button-borderwidth-button-focus) solid var(--fdt-button-color-focus-border);
  }
}
@layer objects {
  .o-col-count {
    column-count: var(--column-count, 1);
    column-gap: var(--column-gap, var(--fdt-core-spacing-4));
  }
  .o-col-count--2 {
    --column-count: 2;
  }
  .o-col-count--3 {
    --column-count: 3;
  }
  @media screen and (max-width: 63.9375em) {
    .o-col-count--1\@tablet {
      --column-count: 1;
    }
    .o-col-count--3\@tablet {
      --column-count: 3;
    }
  }
  @media screen and (max-width: 39.9375em) {
    .o-col-count--1\@mob {
      --column-count: 1;
    }
    .o-col-count--2\@mob {
      --column-count: 2;
    }
  }
}
@layer objects {
  .o-dl {
    display: grid;
    grid-template-columns: var(--dl--gtc, minmax(50%, 1fr) auto);
    grid-gap: var(--dl--gap, var(--fdt-core-spacing-1) var(--fdt-core-spacing-2));
  }
  .o-dl dt {
    word-break: break-word;
  }
  .o-dl dd {
    font-weight: var(--fdt-semantic-typography-description-fontweight);
    letter-spacing: var(--fdt-semantic-typography-description-letterspacing);
    text-wrap: balance;
  }
}
@layer objects {
  .o-sticky-container {
    position: fixed;
    bottom: 0;
    flex-direction: column;
    display: flex;
    align-items: flex-end;
    width: 100%;
    z-index: var(--z-index-mars);
    pointer-events: none;
  }
  .o-sticky-container__inner {
    margin-right: 50px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  @media screen and (max-width: 63.9375em) {
    .o-sticky-container__inner {
      width: 100%;
      margin-right: 0;
    }
  }
  .o-sticky-container__item {
    pointer-events: all;
  }
  @media screen and (max-width: 26.5em) {
    .o-sticky-container__item {
      width: 100%;
    }
  }
  .o-sticky-container__item + .o-sticky-container__item {
    margin-top: var(--fdt-core-spacing-2);
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */